import { useCallback } from 'react';
import { Editor, Node } from 'slate';
import { getDiffClass, getNodeId, leafsInRange } from '../compareUtils';

export const withDecorateCompare =
  (options = {}) =>
  (editor) => {
    const { side, diffState } = options;
    return useCallback(
      ([node, path]) => {
        const ranges = [];
        const diffs = diffState?.[side];
        if (!diffs[getNodeId(node)]) {
          return ranges;
        }

        const changes = diffs[getNodeId(node)];

        if (changes.state !== 'changed') {
          return ranges;
        }
        switch (changes.type) {
          case 'table':
            changes.computedDiff
              ?.filter((change) => change[0] === 0 || change[0] === -1)
              .reduce(
                (acc, change) => {
                  if (change[0] === -1) {
                    const range = Editor.range(node);
                    acc[1].push({ ...range });
                  }

                  acc[0] += change[1].length;
                  return acc;
                },
                [0, []]
              )[1]
              .forEach((decoration) => ranges.push(decoration));
            break;
          case 'numbered-list':
          case 'bulleted-list':
            changes.computedDiff?.forEach(([op, text], index) => {
              if (op === 0 || !Array.isArray([op, text])) return;

              const liPath = [...path, index];
              let liNode;
              try {
                liNode = Node.get(editor, liPath);
              } catch {
                return;
              }

              if (liNode.type !== 'list-item') return;

              const textNodes = Array.from(Node.texts(liNode));
              if (textNodes.length > 0) {
                textNodes.forEach(([textNode, textPath]) => {
                  const len = textNode.text.length;
                  ranges.push({
                    anchor: { path: [...liPath, ...textPath], offset: 0 },
                    focus: { path: [...liPath, ...textPath], offset: len },
                    highlight: getDiffClass(side),
                  });
                });
              } else {
                ranges.push({
                  anchor: { path: liPath, offset: 0 },
                  focus: { path: liPath, offset: 0 },
                  highlight: getDiffClass(side),
                });
              }
            });
            break;

          default:
            changes.computedDiff
              ?.filter((change) => change[0] === 0 || change[0] === -1)
              .reduce(
                (acc, change) => {
                  if (change[0] === -1) {
                    const lir = leafsInRange(path, node, acc[0], acc[0] + change[1].length, side, change);
                    acc[1].push(lir);
                  }

                  acc[0] += change[1].length;
                  return acc;
                },
                [0, []]
              )[1]
              .forEach((decoration) => ranges.push(decoration));
        }

        return ranges;
      },
      [diffState, editor, side]
    );
  };
